<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side
          side-nav(
            v-bind:sideNavData="sideNavData"
          )
        .profile-page__main
          .profile-page__header
            .profile-page__title
              h1.title {{ profileData.title }}
            .profile-page__description {{ profileData.description }}
          .profile-page__body
            //- По дефолту
            .childs(
              v-show="!showChild"
            )
              .childs__list(
                v-if="childsData.length > 0"
              )
                .childs-list
                  .childs-list__item(
                    v-for="child in childsData"
                  )
                    .child-card(
                      @click="onAddNewChild(child)"
                    )
                      .child-card__photo(
                        v-bind:style="getLocalAvatarUrl(child.avatar.file)"
                      )
                      .child-card__name {{ child.last_name }} {{ child.first_name }} {{ child.fathers_name }}
                  //- .childs-list__item
                  //-   .child-card
                  //-     .child-card__photo
                  //-     .child-card__name Султанов Рамиль Рустамович
              .childs__button-add
                button(
                  type="button"
                  @click="onAddNewChild()"
                ).button.button_paint-main Добавить ребенка
            //- Форма добавления
            form(
              v-if="showChild"
            )
              .profile-page-form
                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Общая информация ребенка

                  .profile-section__body
                    form-child-info(
                      :avatar="childData.avatar"
                      :last-name="childData.last_name"
                      :first-name="childData.first_name"
                      :fathers-name="childData.fathers_name"
                      :gender="childData.gender"
                      :date-of-birth="childData.date_of_birth"
                      :nationality="childData.nationality"
                      :place-of-birth="childData.place_of_birth"
                      @onChangeValue="changeValue"
                      @onChangeChildBirth="changeChildBirth"
                      :require-errors="requireErrors"
                      :keymonitor="keymonitor"
                    )
                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Адрес регистрации
                  .profile-section__body
                    form-address(
                    :address="childData.registration_address"
                    :field="'registration_address'"
                    @on-change-value="changeAddress"
                    :require-errors="requireErrors"
                    :keymonitor="keymonitor"
                    :show-attachments="true"
                    :attachments="childData.registration_documents_attachments"
                    @on-change-attachments="changeValue"
                    )

                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Адрес проживания
                    <!--.profile-section-switch-->
                      <!--.profile-section-switch__text Совпадает  с адресом родителя-->
                      <!--.profile-section-switch__elem-->
                        <!--.form-switch-->
                          <!--label.form-switch__label-->
                            <!--input.form-switch__input(-->
                              <!--type="checkbox"-->
                              <!--v-model="addressesMatch"-->
                              <!--@change="changeCheckboxMatches()"-->
                            <!--)-->
                            <!--.form-switch__outline-->
                            <!--.form-switch__switch-->
                  .profile-section__body
                    form-address(
                    :address="childData.actual_address"
                    :field="'actual_address'"
                    @on-change-value="changeAddress"
                    :require-errors="requireErrors"
                    :keymonitor="keymonitor"
                    )
                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Информация о школе
                  .profile-section__body
                    form-school(
                    :school-info="childData.school_info"
                    @onChangeValue="changeValue"
                    @on-change-school-region="changeSchoolRegion"
                    :require-errors="requireErrors"
                    :keymonitor="keymonitor"
                    :school-certificate-attachments="childData.school_certificate_attachments"
                    )
                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Портфолио ребенка за последние 3 года
                  .profile-section__body
                    form-portfolio(
                      :awards="childData.awards"
                      @onChangeValue="changeValue"
                      :keymonitor="keymonitor"
                    )
                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Документы
                  .profile-section__body
                    form-child-docs(
                      :child-doc-type="childDocType"
                      :birth-certificate="childData.birth_certificate"
                      :birth-certificate-attachments="childData.birth_certificate_attachments"
                      :passport="childData.passport"
                      :passport-issue-date="childData.passport_issue_date"
                      :passport-attachments="childData.passport_attachments"
                      :snils="childData.snils"
                      :snils-attachments="childData.snils_attachments"
                      :inn="childData.inn"
                      :inn-attachments="childData.inn_attachments"
                      @onChangeValue="changeValue"
                      @onChangeDocType="changeDocType"
                      :require-errors="requireErrors"
                      :keymonitor="keymonitor"
                    )
                section.profile-page-form__section.profile-section
                  .profile-section__body
                    .form
                      .form__elem.form__elem_button
                        .form-elem.form-button(
                          v-if="childId !== 'new'"
                        )
                          .form-elem__body
                            button.button.button_paint-secondary.button_long(
                              type="submit"
                              @click.prevent="confirmDelete()"
                            )
                              .button__text Удалить
                        .form-elem.form-button
                          .form-elem__body
                            button.button.button_paint-main.button_long(
                              type="submit"
                              @click="onSaveChild($event)"
                            )
                              .button__text Сохранить
                          .form-elem__error(v-show="showError") Не все поля заполнены

    .profile-page__footer.page__footer
      main-footer
</template>
<script>
import {mapState, mapActions} from "vuex";

import MainFooter from "@/components/footer/Footer";
import SideNav from "@/components/sideNav/SideNav";
import FormChildInfo from "../components/forms/FormChildInfo";
import FormAddress from "../components/forms/FormAddress";
import FormSchool from "../components/forms/FormSchool";
import FormPortfolio from "../components/forms/FormPortfolio";
import FormChildDocs from "../components/forms/FormChildDocs";

export default {
  name: "MyChilds",
  components: {
    FormChildDocs,
    MainFooter,
    FormPortfolio,
    FormSchool,
    FormAddress,
    SideNav,
    FormChildInfo
  },
  props: ["sideNavData"],
  data() {
    return {
      showChild: false,
      addressesMatch: false,
      childDocType: true,
      childDocRequires: {
        true: ["birth_certificate", "birth_certificate_attachments"],
        false: [
          "passport",
          "passport_issue_date",
          // "passport_issue_by",
          "passport_attachments",
          "inn",
          // "snils",
          // "snils_attachments",
          "inn_attachments"
        ]
      },
      profileData: {
        title: "Мои дети",
        description:
          "Добавьте и заполните анкету ребенка, чтобы отправлять заявки в лагеря"
      },
      childData: {},
      childsData: [],
      requireErrors: {
        first_name: false,
        last_name: false,
        fathers_name: false,
        gender: false,
        date_of_birth: false,
        place_of_birth: false,
        nationality: false,
        "registration_address.region": false,
        "registration_address.area": false,
        "registration_address.city": false,
        "registration_address.street": false,
        "registration_address.house": false,
        "registration_address.postal_code": false,
        "actual_address.region": false,
        "actual_address.area": false,
        "actual_address.city": false,
        "actual_address.street": false,
        "actual_address.house": false,
        "actual_address.postal_code": false,
        // passport: false,
        // passport_issue_date: false,
        // passport_issue_by: false,
        // passport_attachments: false,
        // inn: false,
        // birth_certificate: false,
        // inn_attachments: false,
        // birth_certificate_attachments: false,
        "school_info.region": false,
        "school_info.area": false,
        "school_info.school": false,
        "school_info.class": false,
        snils: false,
        snils_attachments: false,
        registration_documents_attachments: false,
        school_certificate_attachments: false
      },
      defaultActualAddress: {},
      showError: false
    };
  },
  computed: {
    ...mapState(["userData"]),
    defaultChildData() {
      return {
        avatar: {},
        awards: [],
        first_name: "",
        last_name: "",
        fathers_name: "",
        gender: null,
        date_of_birth: "",
        place_of_birth: "",
        nationality: "",
        registration_address: {
          region: "",
          area: "",
          city: "",
          street: "",
          house: "",
          apartment: "",
          postal_code: ""
        },
        actual_address: {
          region: "",
          area: "",
          city: "",
          street: "",
          house: "",
          apartment: "",
          postal_code: ""
        },
        passport: "",
        passport_issue_date: null,
        passport_issue_by: "",
        passport_attachments: [],
        inn: "",
        snils: "",
        birth_certificate: "",
        snils_attachments: [],
        inn_attachments: [],
        birth_certificate_attachments: [],
        school_info: {
          region: "",
          school: "",
          class: "",
          class_profile: ""
        },
        registration_documents_attachments: [],
        school_certificate_attachments: []
      };
    },
    childId() {
      return this.$route.query.child_id;
    }
  },
  methods: {
    ...mapActions(["addChild", "getChilds", "updateChild", "deleteChild"]),
    changeCheckboxMatches() {
      if (this.addressesMatch) {
        const parentAddress = JSON.parse(
          JSON.stringify(this.userData.actual_address)
        );
        this.defaultActualAddress = JSON.parse(
          JSON.stringify(this.childData.actual_address)
        );
        this.childData.actual_address = parentAddress;
      } else {
        this.childData.actual_address = this.defaultActualAddress;
      }
    },
    onAddNewChild(child) {
      if (child) {
        this.childData = JSON.parse(JSON.stringify(child));
      } else {
        this.childData = JSON.parse(JSON.stringify(this.defaultChildData));
      }
      if (this.childData.passport.length > 0) {
        this.childDocType = false;
      }
      this.showChild = true;
      this.$router.push({
        name: "MyChilds",
        query: {child_id: child ? child.id : "new"}
      });
    },
    changeAddress(field, item, val) {
      this.childData[field][item] = val;
    },
    changeValue(data) {
      const type = data[1];
      const value = data[0];
      this.childData[type] = value;
    },
    changeSchoolRegion(val) {
      //костыль, там весь formSchool надо переписывать
      this.childData.school_info.region = val;
    },
    changeChildBirth(date) {
      const today = new Date().valueOf();
      const childDate = new Date(date).valueOf();
      const diff = new Date(today - childDate);
      const childAge = diff.getFullYear() - 1970;
      if (childAge > 15) {
        this.childDocType = false;
        this.$set(this.requireErrors, "inn", false);
        this.$set(this.requireErrors, "snils", false);
        this.$set(this.requireErrors, "passport", false);
        this.$set(this.requireErrors, "passport_issue_date", false);
      } else {
        this.childDocType = true;
        this.$delete(this.requireErrors, "inn");
        this.$delete(this.requireErrors, "snils");
        this.$delete(this.requireErrors, "passport");
        this.$delete(this.requireErrors, "passport_issue_date");
      }
    },
    changeDocType(data) {
      this[data[1]] = data[0];
      this.keymonitor();
    },
    keymonitor() {
      Object.keys(this.requireErrors).map(error => {
        this.requireErrors[error] = false;
        return error;
      });
      this.showError = false;
    },
    checkRequires() {
      let errors = [];
      const requires = Object.keys(this.requireErrors);
      requires.map(_require => {
        const require = _require.split(".");
        if (require.length > 1) {
          const value = this.childData[require[0]][require[1]];
          if (require[0] === "school_info" && require[1] === "area") {
            if (this.childData.school_info.region.toLowerCase().includes("татарстан")) {
              if (!value || value.length === 0) {
                errors.push(_require);
              }
            }
          } else {
            if (!value || value.length === 0) {
              errors.push(_require);
            }
          }
        } else {
          if (
            this.childData[require] === null ||
            this.childData[require].length === 0
          ) {
            errors.push(...require);
          }
        }
      });
      const docsRequires = this.childDocRequires[!this.childDocType];
      errors = errors.filter(el => docsRequires.indexOf(el) < 0);
      errors.map(error => {
        this.requireErrors[error] = true;
        return error;
      });
      return errors.length > 0;
    },
    confirmDelete() {
      this.$root.$emit("onShowConfirmModal", {
        text: "Уверены,что хотите удалить этот профиль?",
        buttonConfirmFunc: {
          func: this.onDeleteChild
        }
      });
    },
    onDeleteChild() {
      this.deleteChild(this.childId).then(res => {
        if (res.status === 204) {
          this.$router.push({name: "MyChilds"});
          this.$root.$emit("onShowNotificationModal", {
            text: "Профиль ребенка удален!"
          });
        } else if (res.status === 400) {
          this.$root.$emit("onShowErrorModal", {
            text:
              "Профиль этого ребёнка используется в активной заявке. В данный момент удаление невозможно."
          });
        }
      });
      this.updateChildsData();
    },
    onSaveChild(e) {
      e.preventDefault();
      const childData = JSON.parse(JSON.stringify(this.childData));
      if (this.checkRequires()) {
        this.showError = true;
        return;
      }

      if (!childData.school_info.area) {
        childData.school_info.area = "";
      }

      childData.birth_certificate_attachments = childData.birth_certificate_attachments.map(
        el => el.id
      );
      childData.passport_attachments = childData.passport_attachments.map(
        el => el.id
      );
      childData.snils_attachments = childData.snils_attachments.map(
        el => el.id
      );
      childData.inn_attachments = childData.inn_attachments.map(
        el => el.id
      );
      childData.registration_documents_attachments = childData.registration_documents_attachments.map(
        el => el.id
      );
      childData.school_certificate_attachments = childData.school_certificate_attachments.map(
        el => el.id
      );

      childData.awards = childData.awards.map(el => el.id);
      childData.avatar = childData.avatar.id ? [childData.avatar.id] : [];
      const childId = this.$route.query.child_id;

      const docsRequires = this.childDocRequires[!this.childDocType];
      docsRequires.map(doc => {
        if (doc.indexOf("attachments") > -1) {
          childData[doc] = [];
        } else if (doc === "passport_issue_date") {
          childData[doc] = null;
        } else {
          childData[doc] = "";
        }
        return doc;
      });

      if (childId !== "new") {
        this.updateChild({data: childData, id: childId}).then(res => {
          const data = res.data;
          if (res.status === 200) {
            this.childsData = this.childsData.map(child => {
              if (child.id === data.id) {
                data.avatar = data.avatar ? {...data.avatar[0]} : {};
                child = data;
              }
              return child;
            });
            this.$router.push({name: "MyChilds"});
            this.$root.$emit("onShowNotificationModal", {
              text: ""
            });
            this.childDocType = true;
          }
        });
      } else {
        this.addChild(childData).then(res => {
          const data = res.data;
          if (res.status === 201) {
            data.avatar = data.avatar ? {...data.avatar[0]} : {};
            this.childsData.push(data);
            this.$router.push({name: "MyChilds"});
            this.$root.$emit("onShowNotificationModal", {
              text: ""
            });
            this.childDocType = true;
          }
        });
      }
    },
    onBuildChild() {
      const childId = this.$route.query.child_id;
      this.addressesMatch = false;
      if (childId) {
        if (childId !== "new") {
          const childData = this.childsData.find(
            child => child.id === Number(childId)
          );
          const noAddressMatches = [];
          const childActualAddress = childData.actual_address;
          const parentActualAddress = this.userData.actual_address;
          Object.keys(parentActualAddress).map(el => {
            if (parentActualAddress[el] !== childActualAddress[el]) {
              noAddressMatches.push(el);
            }
          });
          this.addressesMatch = noAddressMatches.length === 0;
          this.childData = JSON.parse(JSON.stringify(childData));
        } else {
          this.addressesMatch = false;
          this.childData = JSON.parse(JSON.stringify(this.defaultChildData));
        }
        if (this.childData.passport.length > 0) {
          this.childDocType = false;
        } else {
          this.childDocType = true;
        }
        this.showChild = true;
      } else {
        this.showChild = false;
      }
    },
    getLocalAvatarUrl(url) {
      return url ? "background-image: url(" + url + ")" : "";
    },
    updateChildsData() {
      this.getChilds().then(data => {
        data = data.map(el => {
          el.avatar = el.avatar ? {...el.avatar[0]} : {};
          return el;
        });
        this.childsData = data;
        this.onBuildChild();
      });
    }

  },
  mounted() {
    this.updateChildsData();
    // let params = {
    //   count: 5,
    //   query: "Школа"
    // };
    // this.getSuggetionDaDataOrg(params)
  },
  watch: {
    "$route.query.child_id"() {
      this.onBuildChild();
    }
  }
};
</script>
